import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import UserList from './UserList'
import ProfilePage from './profile_page_container'
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from './Modal'
import axios from 'axios'
import { leftArrowTip } from '../../../Templates/icons'
class UserManagementPage extends Component {
    signal = axios.CancelToken.source()
    state = {
        selectedUser: null,
        isLoading: true,
        openModal: false,
        userRole: null,
        newRole: null,
        userRoleModal: false,
        userCreated: false,
        isLoadingUser: false,
    }

    componentDidMount = () => {
        this.loadData()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.userCreated !== this.state.userCreated && this.state.userCreated === true) {
            this.setState({ isLoadingUser: true }); // Set loading state to true
            setTimeout(() => { 
                this.loadData();
                this.setState({ userCreated: false, isLoadingUser: false});
            }, 4000)
        }
    }

    setUserCreated = () => {
      this.setState({ userCreated: true });
    };

    componentWillUnmount = () => {
        this.signal.cancel('Api is being canceled');
        clearTimeout(this.timeout)
    }

    // api requests are made with a AbortController cancel token. When the component unmounts the api request is aborted,
    loadData = () => {
        Promise.all([
            this.props.fetchAllUsers(this.signal.token),
        ]).then(([res1]) => {
            this.setState({ isLoading: false })
        }).catch(err => {
            if (axios.isCancel(err)) {
                console.info('User Management Page - ', err.message)
            } else {
                console.debug('Error', err.message)
            }
        });
    }



    displayModal = () => {
        return this.state.openModal ? 
        <Modal 
            modalTitle={""}
            closeModal={this.closeModal}
            callingComponent={"User Management Page"}
            submitForm={this.submitForm}
            currentRole={this.state.userRole}
            modifyRole={this.modifyRole}
            setUserCreated={this.setUserCreated}
        /> 
        : null
    }

    closeModal = () => {
        this.setState({openModal: false})
    }

    openModal = () => {
        this.setState(prevState => ({ openModal: !prevState.openModal}))
    }

    submitForm = (url) => {
        this.setState(prevState => ({
            openModal: false,
            url: url
        }))
    }

    modifyRole = (role) => {
        if (role !== this.state.userRole) {
            this.setState({userRole: role}, this.confirmChanges)
        } else {
            return
        }
    }

    confirmChanges = () => {
        let payload={
            userRole: this.state.userRole,
        }
    }

    selectUser = (id) => {
        let selectedUser = this.props.users[id]
        let previouslySelected = selectedUser === this.state.selectedUser
        let differentUser = this.state.selectedUser && this.state.selectedUser._id !== id
        if (previouslySelected && !differentUser) {
            this.clearUrl()
            return this.setState({selectedUser: null})
        } else if (differentUser) {
            this.clearUrl()
            return this.setState({selectedUser : null}, () => this.setState({selectedUser}))
        }
        return this.setState({ selectedUser })
    }

    clearUrl = () => {
        this.props.history.push('/dashboard/management/users')
    }

    renderLoading = () => {
        this.timeout = setTimeout(() => this.setState({loadingUser: true}), 1000)
        return <div className="flex-centered max-size">
            <CircularProgress />
        </div>
    }

    renderActivityIcon = (status="") => {
        status = status.toLowerCase()
        switch (status) {
            case "online":
                return <svg className="status-icon-circle" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '.25em', marginBottom: '.1em' }}>
                    <ellipse cx="8" cy="8" rx="8" ry="8" fill={'#228b22'} />
                </svg>
            case "idle":
                return <svg className="status-icon-circle" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '.25em', marginBottom: '.1em' }}>
                    <ellipse cx="8" cy="8" rx="8" ry="8" fill={'orange'} />
                </svg>
            case "offline":
                return <svg className="status-icon-circle" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '.25em', marginBottom: '.1em' }}>
                    <ellipse cx="8" cy="8" rx="8" ry="8" fill={'#cdcdcd'} />
                </svg>
            default:
                return null
        }
    }

    render = () => {
        const selectedUser = this.state.selectedUser
        const { isLoadingUser } = this.state;
        return <div className="user-manager-page-window max-width rel" style={{ height: "calc(100% - 47px)" }}>
                <Fragment>
                    {this.displayModal()}
                </Fragment>
                <div id="user-manager-page-content" className={`max-size flex ${this.state.openModal ? "modal-open" : ""}`}>
                    <UserList
                        selectedUser={selectedUser}
                        users={Object.values(this.props.users)}
                        loading={this.state.isLoading}
                        selectUser={this.selectUser}
                        openModal={this.openModal}
                        closeModal={this.closeModal}
                        currentUserRole={this.props.currentUserRole}
                        isLoadingUser={this.state.isLoadingUser}
                    />
                    {/* renders summary if a work instruction has been selected, else renders directions */}
                    {selectedUser ?
                    <ProfilePage id={selectedUser._id}/>
                        :
                        <div id="user-summary-container" className="flex-column shadow">
                            <div id="directions-panel" className="flex-column-centered max-height">
                                {this.state.isLoading ? <h3 className="pageTitleFontSize">User list is loading</h3>
                                    : <div className="flex-centered">
                                        {leftArrowTip}
                                        <h3 className="pageTitleFontSize" >Select a user to view/edit information.</h3>
                                    </div>}
                            </div>
                        </div>}
                </div>
        </div>
    }
}

export default withRouter(UserManagementPage)